<!--
 * @Author: xiaokun
 * @Date: 2020-04-12 18:45:22
 * @LastEditors: xiaokun
 * @LastEditTime: 2020-04-12 18:49:50
 * @Description: 商品标签
 -->
<template>
  <div class="list-table-commodity-tags">
    <span
      v-for="(commodityTags, index) in scope.row.commodityTags.slice(0,3)"
      :key="index"
      class="commodity-tag-item"
    >
      {{ commodityTags }}
    </span>
    <span v-if="scope.row.commodityTags.length > 3">
      <keyword-popover
        :is-commodity="true"
        :keyword-list="scope.row.commodityTags"
        width="270"
      />
    </span>
  </div>
</template>

<script>
import KeywordPopover from '@components/keyword-popover/index.vue'
export default {
  name: 'ListTableColumnTag',
  components: {
    KeywordPopover
  },
  props: {
    scope: {
      type: Object,
      default () {
        return {}
      }
    }
  }
}
</script>
<style  lang="scss" scoped>
.list-table-commodity-tags {
  .commodity-tag-item {
    display: inline-block;
    box-sizing: border-box;
    font-size: 12px;
    padding: 0 8px;
    background-color: #e6f2ff;
    color: #409fff;
    margin-right: 8px;
    border-radius: 2px;
  }
}

</style>
